/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Acrobat_PlatformsInputs */

const en_pc_alt_t_acrobat_platforms = /** @type {(inputs: Pc_Alt_T_Acrobat_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, iOS, Android, web. No Linux desktop app`)
};

const zh_pc_alt_t_acrobat_platforms = /** @type {(inputs: Pc_Alt_T_Acrobat_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、iOS、Android、网页。没有 Linux 桌面版`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, iOS, Android, web. No Linux desktop app" |
*
* @param {Pc_Alt_T_Acrobat_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_acrobat_platforms = /** @type {((inputs?: Pc_Alt_T_Acrobat_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Acrobat_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_acrobat_platforms(inputs)
	return zh_pc_alt_t_acrobat_platforms(inputs)
});
export { pc_alt_t_acrobat_platforms as "pc.alt.t.acrobat.platforms" }